import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { Offline, Online } from "react-detect-offline";
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react'

import { SetUpPosthog } from 'components/features/shared/SetUpPosthog';
import { router } from 'config/router/router';
import { store } from 'store/storeConfig';
import OfflinePage from 'pages/OfflinePage';

import 'reactflow/dist/style.css';
import 'react-toastify/dist/ReactToastify.css';
import 'simplebar-react/dist/simplebar.min.css';
import TagManager from 'react-gtm-module';
import FreshworksWidget from 'utils/helpWidget/FreshworksWidget';
import { GTM_CONTAINER_ID } from 'utils/setting';
import { useAuth } from "react-oidc-context";
import { TourProvider } from 'components/ui/joyRide/TourContext';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
})

SetUpPosthog();

//initialize google tag manager
const tagManagerArgs = {
  gtmId: GTM_CONTAINER_ID || process.env.REACT_APP_GTM_CONTAINER_ID as string
};
TagManager.initialize(tagManagerArgs);

function App() {
  const { isAuthenticated } = useAuth();

  // intialize freshworks help widget
  // useFreshworksWidget(501000000591,user);

  return (<React.Fragment>
    <PostHogProvider client={posthog}>
      <Online polling={false}>
        <QueryClientProvider client={queryClient}>
          <Provider store={store}>
            <TourProvider>  {/*for joyride tour */}
              <ReactQueryDevtools initialIsOpen={false} />
              {isAuthenticated && <FreshworksWidget widgetId={501000000591} />}
              <ToastContainer />
              <RouterProvider router={router} />
            </TourProvider>
          </Provider>
        </QueryClientProvider>
      </Online>


      <Offline polling={false}><OfflinePage /></Offline>
    </PostHogProvider>
  </React.Fragment>);
}

export default App;
